import React, { useContext } from 'react';
import PropTypes from 'prop-types';

import { CustomerContext } from '../../../../contexts/customer-context';

import StatusIndicator from '../../../../component-library/status-indicator';

const SpecificationUnavailable = ({
	name,
}) => {
	const {
		missing: {
			specs: {
				itemstate: missingState,
			} = {},
		} = {},
	} = useContext(CustomerContext);

	return (
		<div className="bundle-details__container">
			<div className="bundle-details__details-unavailable">
				<h4 className="grey-text display-inline-block margin-right-16">{name}</h4>
				<div className="display-inline-block">
					<StatusIndicator state={missingState} />
				</div>
				<p className="margin-bottom-none grey-text">This API has not been promoted to the portal.</p>
			</div>
		</div>
	);
};

export default SpecificationUnavailable;

SpecificationUnavailable.propTypes = {
	name: PropTypes.string.isRequired,
};
